// Meta Pixel for public forms: loads once per pixel id, PageView on load, Lead on submit (eventID = lead id for CAPI dedupe).
const loaded = new Set();

export function initPixel(id) {
  const pid = String(id || "").trim();
  if (!pid || loaded.has(pid)) return;
  if (!window.fbq) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
  }
  window.fbq("init", pid);
  window.fbq("track", "PageView");
  loaded.add(pid);
}

export function trackLead(id, eventId) {
  if (!String(id || "").trim() || !window.fbq) return;
  window.fbq("track", "Lead", {}, { eventID: String(eventId || "") });
}
